const initAccordions = () => {
    
    const accordions = document.querySelectorAll('.accordion-item');
    if (!accordions.length) { return; }

    accordions.forEach(function (accordion) {
        if (accordion.classList.contains('active')) {
            accordion.querySelector('.accordion__body').style.display = 'block'
        }
    });

    accordions.forEach(function (accordion) {
        const trigger = accordion.querySelector('.accordion__trigger');
        trigger.addEventListener('click', function () {

            // Prevent action if this accordion is already active
            if (accordion.classList.contains('active')) return;

            const content = accordion.querySelector('.accordion__body')
            const siblings = Array.prototype.filter.call(accordions, function(el) {
                return el !== accordion
            });

            if (accordion.classList.contains('active')) {
                accordion.classList.remove('active')
                content.style.display = 'none'
            } else {
                accordion.classList.add('active')
                siblings.forEach(function (sibling) {
                    sibling.classList.remove('active')
                    sibling.querySelector('.accordion__body').style.display = 'none'
                })
                content.style.display = 'block'
            }
        });

        trigger.addEventListener('click', function () {
            const targetId = this.getAttribute('data-id');
            const targetElement = document.getElementById(targetId);
    
            document.querySelectorAll(".accordion__image").classList.remove('active');
    
            if (targetElement) {
                targetElement.classList.add('active');
            }
        });
    });

    
}

export { initAccordions }